import React from 'react';
import styled from '@emotion/styled';

type Props = {
  size: number;
};

const IconKakao = ({ size }: Props) => {
  return (
    <Svg
      width={size}
      height={size}
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='18' cy='18' r='18' fill='#F0F0F0' />
      <path
        style={{ translate: '8px 9px' }}
        d='M9.99762 0C4.47637 0 0 3.6502 0 8.15397C0 11.0163 1.80955 13.5332 4.54761 14.9899L3.79245 19L8.11684 16.1645C8.72714 16.2593 9.35645 16.3104 10 16.3104C15.5213 16.3104 20 12.6602 20 8.15397C20 3.64777 15.5213 0 9.99762 0Z'
        fill='#4D5CED'
      />
    </Svg>
  );
};

const Svg = styled.svg`
  :hover {
    circle {
      fill: #f5c1c1;
    }
  }
`;

export default IconKakao;
